"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MySubscriptionResponseDtoStoreEnum = exports.MySubscriptionResponseDtoPeriodTypeEnum = exports.MySubscriptionResponseDtoTierEnum = void 0;
exports.instanceOfMySubscriptionResponseDto = instanceOfMySubscriptionResponseDto;
exports.MySubscriptionResponseDtoFromJSON = MySubscriptionResponseDtoFromJSON;
exports.MySubscriptionResponseDtoFromJSONTyped = MySubscriptionResponseDtoFromJSONTyped;
exports.MySubscriptionResponseDtoToJSON = MySubscriptionResponseDtoToJSON;
exports.MySubscriptionResponseDtoToJSONTyped = MySubscriptionResponseDtoToJSONTyped;
var PendingChangeDto_1 = require("./PendingChangeDto");
var SubscriptionEntitlementsDto_1 = require("./SubscriptionEntitlementsDto");
var GracePeriodDto_1 = require("./GracePeriodDto");
/**
 * @export
 */
exports.MySubscriptionResponseDtoTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * @export
 */
exports.MySubscriptionResponseDtoPeriodTypeEnum = {
    Normal: 'normal',
    Trial: 'trial',
    Intro: 'intro',
    Prepaid: 'prepaid'
};
/**
 * @export
 */
exports.MySubscriptionResponseDtoStoreEnum = {
    AppStore: 'APP_STORE',
    PlayStore: 'PLAY_STORE',
    Promotional: 'PROMOTIONAL',
    MacAppStore: 'MAC_APP_STORE',
    Unknown: 'UNKNOWN'
};
/**
 * Check if a given object implements the MySubscriptionResponseDto interface.
 */
function instanceOfMySubscriptionResponseDto(value) {
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    if (!('planCode' in value) || value['planCode'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    if (!('autoRenew' in value) || value['autoRenew'] === undefined)
        return false;
    if (!('entitlements' in value) || value['entitlements'] === undefined)
        return false;
    if (!('selectedSportCodes' in value) || value['selectedSportCodes'] === undefined)
        return false;
    return true;
}
function MySubscriptionResponseDtoFromJSON(json) {
    return MySubscriptionResponseDtoFromJSONTyped(json, false);
}
function MySubscriptionResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tier': json['tier'],
        'planCode': json['planCode'],
        'status': json['status'],
        'provider': json['provider'],
        'autoRenew': json['autoRenew'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'trialEndsAt': json['trialEndsAt'] == null ? undefined : json['trialEndsAt'],
        'currentPeriodStart': json['currentPeriodStart'] == null ? undefined : json['currentPeriodStart'],
        'cancelledAt': json['cancelledAt'] == null ? undefined : json['cancelledAt'],
        'periodType': json['periodType'] == null ? undefined : json['periodType'],
        'store': json['store'] == null ? undefined : json['store'],
        'entitlements': (0, SubscriptionEntitlementsDto_1.SubscriptionEntitlementsDtoFromJSON)(json['entitlements']),
        'selectedSportCodes': json['selectedSportCodes'],
        'gracePeriod': json['gracePeriod'] == null ? undefined : (0, GracePeriodDto_1.GracePeriodDtoFromJSON)(json['gracePeriod']),
        'pendingChange': json['pendingChange'] == null ? undefined : (0, PendingChangeDto_1.PendingChangeDtoFromJSON)(json['pendingChange']),
    };
}
function MySubscriptionResponseDtoToJSON(json) {
    return MySubscriptionResponseDtoToJSONTyped(json, false);
}
function MySubscriptionResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'tier': value['tier'],
        'planCode': value['planCode'],
        'status': value['status'],
        'provider': value['provider'],
        'autoRenew': value['autoRenew'],
        'expiresAt': value['expiresAt'],
        'trialEndsAt': value['trialEndsAt'],
        'currentPeriodStart': value['currentPeriodStart'],
        'cancelledAt': value['cancelledAt'],
        'periodType': value['periodType'],
        'store': value['store'],
        'entitlements': (0, SubscriptionEntitlementsDto_1.SubscriptionEntitlementsDtoToJSON)(value['entitlements']),
        'selectedSportCodes': value['selectedSportCodes'],
        'gracePeriod': (0, GracePeriodDto_1.GracePeriodDtoToJSON)(value['gracePeriod']),
        'pendingChange': (0, PendingChangeDto_1.PendingChangeDtoToJSON)(value['pendingChange']),
    };
}
